module.exports = __webpack_public_path__ + "1a0c9e94a80ae9141cb85aadf66e7a5b.svg";